<script>
import { useNavigate } from "svelte-navigator";
import {containFill, timeWindow} from './util';
import { onMount } from 'svelte';

const navigate = useNavigate();

function goLink(link) {
  if (link.startsWith("http")) {
    window.open(link, "_blank");
  } else {
    navigate(link);
  }
}

const floorImageSize = {width: 1920, height: 1080};

// x y is px value relative to image center
let indicators = [
  {x: 600, y: -50, label: 'Winners Archive', path: '/winners', class: ''},
  {x: -350, y: 200, label: 'Schedule', path: '/schedule', class: ''},
  {x: 0, y: -200, label: 'Main Stage', path: '/stage', class: ''},
  // {x: -650, y: -50, label: 'Concepts Gallery', path: '/', class: ''},
  // {x: 300, y: 200, label: 'Vote!', path: 'https://app.sli.do/event/1Uo3LwPqRhWN7mEVxYgBoF/embed/polls/38ff70c7-afdc-4b32-9d2f-5304b24e3530', class: ''}
];

let tiles = [
  {title: 'MAIN STAGE', img: '/img/mobile-stage.jpg', path: '/stage'},
  {title: 'SCHEDULE', img: '/img/mobile-schedule.jpg', path: '/schedule'},
  // {title: 'CONCEPTS GALLERY', img: '/img/mobile-concepts.png', path: '/'},
  // {title: 'VOTE!', img: '/img/mobile-vote.jpg', path: 'https://app.sli.do/event/1Uo3LwPqRhWN7mEVxYgBoF/embed/polls/38ff70c7-afdc-4b32-9d2f-5304b24e3530'},
  {title: 'WINNERS ARCHIVE', img: '/img/mobile-winners.jpg', path: '/winners'}
]

onMount(() => {
  const sub1 = timeWindow(new Date(`2022/02/16 17:00 EST`), new Date(`2022/02/17 12:00 EST`)).subscribe(enabled => {
    if (enabled) {
      indicators.push({id: 'vote', x: 300, y: 200, label: 'Vote!', path: 'https://app.sli.do/event/1Uo3LwPqRhWN7mEVxYgBoF', class: ''})
      tiles.push({id: 'vote', title: 'VOTE!', img: '/img/mobile-vote.jpg', path: 'https://app.sli.do/event/1Uo3LwPqRhWN7mEVxYgBoF'})
      indicators = indicators
      tiles = tiles
    } else {
      indicators = indicators.filter(i => i.id !== 'vote')
      tiles = tiles.filter(i => i.id !== 'vote')
    }
  });

  const sub2 = timeWindow(new Date(`2022/02/16 17:00 EST`), new Date(`2022/02/17 17:00 EST`)).subscribe(enabled => {
    if (enabled) {
      indicators.push({id: 'concept', x: -650, y: -50, label: 'Concepts Gallery', path: 'https://iweek.parallel.live/iWeek 2022 - Concept Gallery.pdf', class: ''})
      tiles.push({id: 'concept', title: 'CONCEPTS GALLERY', img: '/img/mobile-concepts.png', path: 'https://iweek.parallel.live/iWeek 2022 - Concept Gallery.pdf'})
      indicators = indicators
      tiles = tiles
    } else {
      indicators = indicators.filter(i => i.id !== 'concept')
      tiles = tiles.filter(i => i.id !== 'concept')
    }
  });

  return () => {
    sub1.unsubscribe();
    sub2.unsubscribe();
  }
})

let width;
let height;
let scale;

$: if (width > 0 && height > 0) scale = containFill(floorImageSize.width, floorImageSize.height, width, height);
</script>

<div class="color centercenter">
  <div class="background" bind:clientWidth={width} bind:clientHeight={height}>
    <div class="content">
      {#each indicators as i}
        <div class="indicator col hcenter indicator-{i.class}" style="top:{scale * i.y}px;left: {scale * i.x}px" on:click={() => goLink(i.path)}>
          <div class="plus centercenter">
            <i class="material-icons">add</i>
          </div>

          <div class="label centercenter">{i.label}</div>
        </div>
      {/each}
    </div>
  </div>
</div>

<div class="mobile col hcenter">
  {#each tiles as tile}
    <div on:click={() => goLink(tile.path)}>
      <div>{tile.title}</div>
      <img src={tile.img} />
    </div>
  {/each}
  </div>

<style lang="scss">
@import './util';
@import './theme';

.color {
  background-image: url('/img/floor-background.jpg');
  background-size: cover;
  // background-color: white;
  flex: 1;
  height: 100%;

  @include landscape {
    display: none;
  }
}

.background {
  flex: 1;
  align-self: stretch;
  background: url(/img/floor.jpg) no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-position: center center;
  position: relative;
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
}

.indicator {
  position: absolute;
  cursor: pointer;
  transform: translateX(-50%);
  background-repeat: no-repeat;
  background-size: contain;
  width: 310px;
  height: 96px;
}

// .indicator:hover * {
//   background-color: $primary-color;
//   color: white;
// }

// .indicator-helpdesk {
//   background-image: url(/img/floor-buttons/help_desk_btn_default.png);

//   &:hover {
//     background-image: url(/img/floor-buttons/help_desk_btn_rollover.png);
//   }
// }

// .indicator-agenda {
//   background-image: url(/img/floor-buttons/agenda_btn_default.png);
//   &:hover {
//     background-image: url(/img/floor-buttons/agenda_btn_rollover.png);
//   }
// }

// .indicator-mainstage {
//   background-image: url(/img/floor-buttons/main_stage_btn_default.png);
//   &:hover {
//     background-image: url(/img/floor-buttons/main_stage_btn_rollover.png);
//   }
// }

// .indicator-prework {
//   background-image: url(/img/floor-buttons/guest_presenter_btn_default.png);
//   &:hover {
//     background-image: url(/img/floor-buttons/guest_presenter_btn_rollover.png);
//   }
// }

.plus {
  @include shadow;
  display: flex;
  border-radius: 9999px;
  background-color: black;
  color: $primary-color;
  width: 36px;
  height: 36px;
}
.label {
  background-color: black;
  color: $primary-color;
  padding: 4px 16px;
  // border-radius: 5px;
  margin-top: 8px;
  font-weight: 500;
  white-space: nowrap;
  font-size: 22px;
  letter-spacing: 0.05em;
}

.mobile {
  display: none;
  flex-direction: column;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 16px 0;
  background-color: black;
  min-height: calc(100vh - 5rem);
  color: white;

  @include landscape {
    display: flex;
  }

  div {
    color: $primary-color;
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    margin: 8px 0;
  }

  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>